import React, { useEffect, useState } from 'react';
import { getSiteSettings } from '../../api/siteSettings';
import '../../styles/components/_footer.scss';
import {
  FacebookIcon,
  InstagramIcon,
  LinkedinIcon,
  MailIcon,
  LocationIcon,
  PhoneIcon,
  XIcon,
  YoutubeIcon,
} from '../Icons/SiteIcons';

const Footer = () => {
  const [siteSettings, setSiteSettings] = useState(null);

  useEffect(() => {
    const fetchSiteSettings = async () => {
      try {
        const response = await getSiteSettings();
        if (response.isSuccess) {
          setSiteSettings(response.data);
        }
      } catch (error) {
        console.error('Site ayarları yüklenirken hata oluştu:', error);
      }
    };

    fetchSiteSettings();
  }, []);

  return (
    <div className="footer_section">
      <footer className="footer lg-mt-5">
        <div className="footer-container">
          <div className="footer-grid">
            <section className="footer-column">
              <h4>Formlar</h4>
              <ul className="footer-links">
                <li><a href="/iletisim">Öneri ve Şikayetleriniz</a></li>
                <li><a href="/bilgi-edinme-hakki">Bilgi Edinme</a></li>
                <li><a href="/iletisim">Başkana Mesaj</a></li>
                <li><a href="/kvkk-basvuru">KVKK Başvuru Formu</a></li>
              </ul>
            </section>

            <section className="footer-column">
              <h4>Kurumsal</h4>
              <ul className="footer-links">
                <li><a href="/faaliyet-raporlari">Faaliyet Raporları</a></li>
                <li><a href="/meclis-kararlari">Meclis Kararları</a></li>
                <li><a href="/videolar">Video Galeri</a></li>
                <li><a href="/haberler">Haber Arşiv</a></li>
                <li><a href="/basindabiz">Basında Biz</a></li>
                <li><a href="/ihaleler">İhaleler</a></li>
              </ul>
            </section>

            <section className="footer-column footer-column-contact">
              <h4>İletişim</h4>
              <ul className="footer-contact-list">
                <li>
                  <span className="footer-contact-icon"><PhoneIcon size={18} /></span>
                  <div>
                    <strong>Telefon</strong>
                    <a href="tel:4441939">444 19 39</a>
                  </div>
                </li>
                <li>
                  <span className="footer-contact-icon"><MailIcon size={18} /></span>
                  <div>
                    <strong>E-Posta</strong>
                    <a href="mailto:bilgi@iskenderun.bel.tr">bilgi@iskenderun.bel.tr</a>
                  </div>
                </li>
                <li>
                  <span className="footer-contact-icon"><LocationIcon size={18} /></span>
                  <div>
                    <strong>Adres</strong>
                    <span>Yenişehir, Mareşal Fevzi Çakmak Cd. No:48, 31200 İskenderun/Hatay</span>
                  </div>
                </li>
              </ul>

              <div className="footer-contact-actions">
                <div className="footer-social">
                  <div className="footer-social-left">
                    {siteSettings?.youtubeUrl && (
                      <a href={siteSettings.youtubeUrl} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="YouTube">
                        <YoutubeIcon />
                      </a>
                    )}
                    {siteSettings?.twitterUrl && (
                      <a href={siteSettings.twitterUrl} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="X">
                        <XIcon />
                      </a>
                    )}
                    {siteSettings?.facebookUrl && (
                      <a href={siteSettings.facebookUrl} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Facebook">
                        <FacebookIcon />
                      </a>
                    )}
                    {siteSettings?.instagramUrl && (
                      <a href={siteSettings.instagramUrl} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="Instagram">
                        <InstagramIcon />
                      </a>
                    )}
                    {siteSettings?.linkedinUrl && siteSettings.linkedinUrl.trim() !== '' && (
                      <a href={siteSettings.linkedinUrl} target="_blank" rel="noopener noreferrer" className="social-icon" aria-label="LinkedIn">
                        <LinkedinIcon />
                      </a>
                    )}
                  </div>
                </div>

                <a href="/iletisim" className="footer-contact-button">Bize Ulaşın</a>
              </div>
            </section>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="container">
            <p>{siteSettings?.copyrightDescription || 'T.C. İskenderun Belediyesi 2025. Her hakkı saklıdır.'}</p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Footer;
